/* error categories for metricjs */
export const ENGAGEMENT_ERRORS = 'engagement-errors';
export const LOCAL_STORAGE_ERRORS = 'local-storage-errors';
export const WINDOW_ERRORS = 'window-errors';
export const BUTTON_ERRORS = 'button-errors';

/** error_types used in metricjs */
export const LOCAL_STORAGE_SAVE = 'LOCAL_STORAGE_SAVE';
export const ENGAGEMENT_API = 'ENGAGEMENT_API';
export const RTE = 'RTE';
export const INVALID_OWNER_ID = 'INVALID_OWNER_ID';
export const MISSING_INTERACTION_TYPE = 'MISSING_INTERACTION_TYPE';
export const MESSAGE_BUS = 'MESSAGE_BUS';
export const SEQUENCE_ENROLL_ERROR = 'SEQUENCE_ENROLL_ERROR';
export const REFERENCE_RESOLVER_SUBJECT_NAME_ERRORS = 'reference-resolver-subject-name-errors';